import { DialogType } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { AddExternalSiteUsersDialog } from '../components/AddExternalSiteUsersDialog';

const serverAndSiteUsersDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};


function showAddExternalUsersToSiteDialog(dialogScope: ng.IScope, availableQuota: number): ng.IPromise<any> {
  let modalInstance: ModalInstance;
  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss(),
    close: (result: any) => modalInstance && modalInstance.close(result),
    availableQuota: availableQuota
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(AddExternalSiteUsersDialog, dialogProps),
    testId: 'addExternalUsersDialog',
    showCloseButton: true,
    dialogStyle: serverAndSiteUsersDialogStyle,
    shouldNotSetDefaultWidth: true
  });

  return modalInstance.result;
}

export const AddExternalUsersAction = {showAddExternalUsersToSiteDialog};
